import {
    useFreeBuyBonusStore,
    useFreeSpinsBonusesStore,
    useLuckySpinsStore,
    useCountdownFSBonusStore,
    useFreespinsStore,
} from '@stores'

// True while any bonus is awarded or in play. During a bonus the bet is locked to the bonus bet, so
// Ultra Play (which can change the bet) must be unavailable — opening it and changing the bet
// otherwise crashes the game.
//
// There is no single global "in bonus" flag — each bonus type tracks its own state (e.g. free spins
// expose remainingSpins, not activeBonus), so this hook is the single place that aggregates them.
// When a new bonus type is added, register its "active/awarded" signal here.
export const useHasActiveBonus = (): boolean => {
    const fbbActiveBonus = useFreeBuyBonusStore((s) => s.activeBonus)
    const fbbActiveLeft = useFreeBuyBonusStore((s) => s.hasActiveBonusesLeft)
    const fbbActivated = useFreeBuyBonusStore((s) => s.hasActivatedBonus)

    const isFreespinsActive = useFreespinsStore((s) => s.isFreespinsActive)
    const totalFreespins = useFreespinsStore((s) => s.totalFreespins)

    const fsShowRemainingSpinsBanner = useFreeSpinsBonusesStore((state) => state.showRemainingSpinsBanner)
    const lsShowRemainingSpinsBanner = useLuckySpinsStore((state) => state.showRemainingSpinsBanner)
    const cfsShowRemainingSpinsBanner = useCountdownFSBonusStore((state) => state.showRemainingSpinsBanner)
    const areLSAboutToStart = useLuckySpinsStore((state) => state.areLSAboutToStart)

    const showRemainingSpinsBanner =
        fsShowRemainingSpinsBanner || lsShowRemainingSpinsBanner || cfsShowRemainingSpinsBanner

    return Boolean(
        fbbActiveBonus ||
        fbbActiveLeft ||
        fbbActivated ||
        showRemainingSpinsBanner ||
        areLSAboutToStart ||
        isFreespinsActive ||
        totalFreespins > 0
    )
}
